import { render, staticRenderFns } from "./consent-chart-card.vue?vue&type=template&id=73edda90&scoped=true"
import script from "./consent-chart-card.vue?vue&type=script&lang=js"
export * from "./consent-chart-card.vue?vue&type=script&lang=js"
import style0 from "./consent-chart-card.vue?vue&type=style&index=0&id=73edda90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73edda90",
  null
  
)

export default component.exports